export const BIOMETRIC_FACE_ID = 'FaceID';
export const BIOMETRIC_TOUCH_ID = 'TouchID';
export const BIOMETRIC_FINGERPRINT = 'Fingerprint';
export const BIOMETRIC_FACE = 'Face';
export const BIOMETRIC_IRIS = 'Iris';
export const AUTO_LOGIN = 'LOGGED_IN_WITH_BIOMETRICS';

export const LOGIN_TYPE = {
  biometrics: 'biometrics',
  pin: 'pin',
  manual: 'manual',
};
